import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

const PUBLIC_SEO_ARTICLES_PATH = "/api/public/seo-articles";

function publicSeoArticlesUrl(slug) {
  const safeSlug = encodeURIComponent(String(slug || "").trim());
  return resolveApiUrl(`${PUBLIC_SEO_ARTICLES_PATH}/${safeSlug}`);
}

export async function fetchPublicSeoArticle({ slug, siteId }) {
  const params = {};
  if (siteId) params.siteId = String(siteId).trim();

  const { data } = await axios.get(publicSeoArticlesUrl(slug), {
    params,
    timeout: 20000,
    withCredentials: false,
  });
  return data?.article || null;
}
